import { ACTION_TYPE_SENSOR_DATA } from './types';

export const getSensorData = payload => ({
    type: ACTION_TYPE_SENSOR_DATA,
    payload,
});